import { gql } from '$lib/apollo';

export const TESTIMONIAL_FIELDS = gql`
  fragment TestimonialFields on API_Testimonial {
    id
    type
    coachReviewed
    sentiment
    feedback
    createdAt
    dismissedModal
    seller {
      id
      name
      slug
      bio
      avatar {
        original {
          url
        }
      }
      cover {
        original {
          url
        }
      }
    }
    customer {
      id
      name
      slug
      avatar {
        original {
          url
        }
      }
    }
    product {
      id
      name
      slug
    }
  }
`;

// export const TESTIMONIAL_REQUEST_FIELDS = gql`
//   fragment TestimonialRequestFields on TestimonialRequest {
//     id
//     createdAt
//     coach {
//       id
//       avatar
//       coachProfile {
//         id
//         slug
//         name
//         testimonialDiscountEnabled
//         testimonialDiscountPercent
//         title
//       }
//     }
//     student {
//       id
//       name
//     }
//   }
// `;

// export const GET_FAILED_TESTIMONIALS = gql`
//   query getFailedTestimonials {
//     failedTestimonials: testimonials(as: "student", errorDismissed: false, state: [error]) {
//       totalCount
//       pageInfo {
//         hasNextPage
//         endCursor
//       }
//       edges {
//         node {
//           ...TestimonialFields
//         }
//       }
//     }
//   }
//   ${TESTIMONIAL_FIELDS}
// `;

// Used for refetching after removing a testimonial request
// export const GET_TESTIMONIAL_REQUESTS = gql`
//   query GetTestimonialRequests {
//     testimonialRequests {
//       totalCount
//       pageInfo {
//         hasNextPage
//         endCursor
//       }
//       edges {
//         node {
//           ...TestimonialRequestFields
//         }
//       }
//     }
//   }
//   ${TESTIMONIAL_REQUEST_FIELDS}
// `;
